export default "__VITE_ASSET__89189150__"